import React, { useEffect, useMemo, useState } from 'react';
import { fetchShortenedLinks } from './api';
import LinkList from './LinkList';
import '../css/New_Dashboard.css';

const New_Dashboard = () => {
  const [links, setLinks] = useState([]);
  const [lastSync, setLastSync] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [error, setError] = useState('');

  const username = localStorage.getItem('username') || '';

  const fetchLinks = async () => {
    if (!username) {
      setLinks([]);
      setError('Please login again to load your dashboard.');
      return;
    }

    setIsRefreshing(true);
    setError('');
    try {
      const data = await fetchShortenedLinks(username, {
        compact: true,
        limit: 50,
      });
      setLinks(Array.isArray(data) ? data : []);
      setLastSync(new Date());
    } catch (err) {
      console.error('Failed to fetch links:', err);
      setError('Could not load dashboard data right now.');
    } finally {
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    fetchLinks();
  }, []);

  const summary = useMemo(() => {
    const totalLinks = links.length;
    const totalClicks = links.reduce((sum, link) => sum + Number(link.clicks || 0), 0);
    return { totalLinks, totalClicks };
  }, [links]);

  return (
    <div className="dashboard-shell">
      <header className="dashboard-hero">
        <div className="dashboard-hero-top">
          <div>
            <span className="dashboard-kicker">Performance Center</span>
            <h1>{`Welcome back${username ? `, ${username}` : ''}`}</h1>
            <p>Light dashboard mode enabled for faster loading.</p>
          </div>
          <div className="dashboard-hero-actions">
            <button className="primary" type="button" onClick={fetchLinks} disabled={isRefreshing}>
              {isRefreshing ? 'Refreshing...' : 'Refresh Data'}
            </button>
          </div>
        </div>

        <div className="dashboard-glance">
          <div className="glance-card">
            <span>Total Links</span>
            <strong>{summary.totalLinks}</strong>
          </div>
          <div className="glance-card">
            <span>Total Clicks</span>
            <strong>{summary.totalClicks}</strong>
          </div>
        </div>

        <div className="dashboard-meta">
          <span>{lastSync ? `Last sync ${lastSync.toLocaleTimeString()}` : 'Not synced yet'}</span>
          {error ? <span>{error}</span> : null}
        </div>
      </header>

      <div className="dashboard-content">
        <LinkList links={links} onRefresh={fetchLinks} />
      </div>
    </div>
  );
};

export default New_Dashboard;
